/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.registration-forms.forms'},
});

const FormsItem = () => (
  <RouteLinkItem
    route="midas/settings/registration-forms/forms"
    title={messages.title}
  />
);

export default FormsItem;
